import {
    createElement, modal, loadingGif, validateField, clearMessage,
    toggleFieldError, uniformClaimDeadline, localDatetime, ConfirmEmailAddress, loadMember
} from 'commonAssets/js/helpers';
import { i18n, loading, outputDiv, reCAPTCHAv3, userLanguage, appPayMethod } from 'commonAssets/js/constants';
import { DigitalDisbursements, dstPaymentIframeTitle, dstMember, dstFieldset, dstProcess } from 'commonAssets/components/FormBase/DigitalDisbursements';
import { ErrorHandler } from 'commonAssets/utils/ErrorHandler';
import { SubmitClaim } from 'commonAssets/components/Forms/SubmitClaim';
import { e, ee } from 'commonAssets/lib/selector'

export class customSubmitClaim extends SubmitClaim {
    claim_form(params, additionalParams) {
        console.log("[claim_form]")
        // console.log(params)
        // update the claim form deadline
        const deadline_heading = params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(deadline_heading, "text/html");
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], deadline_string.body.innerHTML),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            //params.claim_transactions ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            // appPayMethod ? DigitalDisbursements(params) : ``,
            true ? DigitalDisbursements(params) : ``,
            this.claim_certification(params),
        ]);
        return form;
    }

    init_claim(form) {
        this.claim.api.claimsDeadlineGet({ domain: this.claim.data.domain }).then((result) => {

            // Claim Deadline - Default Pacific DateTime
            let datetime;
            if (Boolean(result.data.pacific_datetime)) {
                datetime = result.data.pacific_datetime;
            }
            else {
                datetime = `<pre>Error: datetime</pre>`;
            }

            let claim_deadline;
            if (Boolean(result.data.claim_deadline)) {
                claim_deadline = result.data.claim_deadline;
            }

            // Error Handling
            if (result.data.error) {
                this.setup_result_data_error(result);
                return;
            }

            const container = createElement("div", {
                class: "display-form",
            });

            /** 
             * Claim Guard
             */
            if (form.form_options.notice_confirmation.display === true) {

                // Guard
                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);


                const zero_zero_id = document.getElementById('zero_zero_id');
                const confirmation_code = document.getElementById('confirmation_code');
                const skip_guard = document.getElementById("skip-guard");

                // Notice Id and Confirmation Code
                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener('change', validateField);
                });

                // Skip Guard
                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        // Hide guard
                        // document.getElementById('guard').classList.add("d-none");
                        document.getElementById('guard').remove();
                        // New Claim Form
                        container.appendChild(this.claim_form(form, datetime));
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);

                        // Init claim fields
                        this.init_claim_fields(this.claim, form, claim_deadline);
                    });
                }

                // ada compliance updates - added
                // if input#submit-guard was clicked add .was-verified to form#guard 
                document.getElementById("submit-guard").addEventListener('click', () => {
                    document.getElementById("guard").classList.add("was-validated");
                    // TODO: add required text to labels
                });

                // Validate Guard Fields
                document.getElementById("guard").addEventListener("submit", (e) => {

                    e.preventDefault();

                    var valid = true;
                    var member = {
                        domain: this.claim.data.domain,
                        zero_zero_id: zero_zero_id.value.toUpperCase(),
                        confirmation_code: confirmation_code.value,
                    };

                    clearMessage();

                    // Validate guard fields
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        valid = validateField(input) && valid;
                    });
                    if (!valid) return;

                    loadingGif(loading, "show");

                    // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    this.claim.api.classMemberPost({}, member).then((result) => {

                        // Check for error message
                        if (result.data.error) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            this.errorHandler.log_exception(new Error('Error loading class member', { cause: result }));
                            this.errorHandler.display_modal(result);
                            return;
                        }
                        
                        let cm_data = result.data.class_member || result.data;
                        if (!cm_data.def_reason) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            modal(i18n.getTranslation('error'), `Your claim has not been marked as deficient. No further action is required at this time.`);
                            loadingGif(loading, "hide", 250);
                            return;
                        }

                        // Add notice id and confirmation code to claim data
                        this.claim.data.zero_zero_id = member.zero_zero_id;
                        this.claim.data.confirmation_code = member.confirmation_code;

                        // Define the environment for the OTP
                        let environment = this.claim.data.domain.split('.')[0]; // ada compliance - added

                        if (result.data.claim_id) {
                            this.claim.data.claim_id = result.data.claim_id;
                            this.claim.class_member = result.data;
                            this.send_otp(form, container, result.data, claim_deadline);
                            return;
                        }

                        // Populate claim form
                        this.populate_claim_form(form, container, result.data, claim_deadline);

                    }).catch((error) => {
                        this.errorHandler.log_exception(new Error('Error loading class member', { cause: error }));
                        this.errorHandler.display_modal(error);
                    });
                });
            }
            /**
             * No Claim Guard
             */
            else {
                // Edit claim link
                this.edit_claim(form);

                // New Claim Form
                let deadlineSpan = uniformClaimDeadline(claim_deadline);
                container.appendChild(this.claim_form(form, deadlineSpan));
                outputDiv.appendChild(container);

                // Init claim fields
                this.init_claim_fields(this.claim, form, claim_deadline);
            }

            loadingGif(loading, "hide", 250)

        }).catch((error) => {
            this.errorHandler.log_exception(new Error('Error fetching claim deadline', { cause: error }));
            this.errorHandler.display(error);
        });
    }

    init_claim_inputs() {
        let claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input, #claim-fields textarea, #claim-fields select, #athlete_name';
        let claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        let claimInputsTransactions = '#transactions input, #transactions textarea, #transactions select';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({ id: class_member.zero_zero_id, email: class_member.email_address });
        // remove guard
        document.getElementById('guard').remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M. 
        let deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
        const cm_data = class_member.class_member || class_member;
        document.getElementById('claim-fields').appendChild(
            createElement("div", { class: "row row-cols-1 row-cols-md-2" }, [
                createElement("div", { class: "col mb-3" }, [
                    createElement("label", { class: "form-label", for: "number_of_athletes" }, [], `Number of Athletes Claimed <span class="error"></span>`),
                    createElement("input", {
                        type: "text",
                        class: "form-control",
                        id: "number_of_athletes",
                        name: "number_of_athletes",
                        "data-validate": "",
                        "data-label": "Number of Athletes Claimed",
                        disabled: true
                    }, [], ``)
                ]),
                createElement("div", { class: "col mb-3" }, [
                    createElement("label", { class: "form-label", for: "number_of_athletes_substantiated" }, [], `Number of Athletes Substantiated by Support <span class="error"></span>`),
                    createElement("input", {
                        type: "text",
                        class: "form-control",
                        id: "number_of_athletes_substantiated",
                        name: "number_of_athletes_substantiated",
                        "data-validate": "",
                        "data-label": "Number of Athletes Substantiated by Support",
                        disabled: true
                    }, [], ``)
                ])
            ])
        );
        document.getElementById('number_of_athletes').value = cm_data.number_of_athletes;
        document.getElementById('number_of_athletes_substantiated').value = cm_data.number_of_athletes_substantiated;
        document.getElementById('claim-fields').appendChild(createElement("div", { class: "mt-3" }, [
            createElement("h4", {}, [], `<strong>Claim Deficiency</strong>`),
            createElement("ul", {}, [], cm_data.def_reason.replaceAll('<br>', '<br><br>'))
        ]));
        document.getElementById('claim-fields').appendChild(
            createElement("div", { class: "d-none" }, [
                createElement("label", { class: "form-label", for: "deficiency_response" }, [], `<span class="error"></span>`),
                createElement("input", {
                    type: "hidden",
                    id: "deficiency_response",
                    name: "deficiency_response",
                    "data-validate": "",
                    "data-label": "Deficiency Response",
                    value: "YES"
                })
            ])
        );
        // Load member data into form
        loadMember(class_member);
        // Payment widget 
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        if (class_member.claim_id && class_member.claim_files.length > 0) {
            this.prev_uploads = true;
        }
        // hide loading gif
        loadingGif(loading, "hide", 250);
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
            claim = dstProcess(this.claim);
        }
        else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
            claim = this.customDstProcess(this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        if (claim.uploads.length == 0 && !this.prev_uploads) {
            claim.flags.valid = false;
            modal("Error", "Please upload supporting documentation.");
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors'));
        }
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {
            // jsb pixels
            fbq('track', 'Lead');
            gtag("event", "generate_lead", {
                currency: "USD",
                value: 1
            });

            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector('div.display-form').classList.add('d-none');

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(i18n.getTranslation('confirmation_screen_additional')['title'], i18n.getTranslation('confirmation_screen_additional')['body']);
            }, 250);

        } else {
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_submit_error'));
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(document.querySelectorAll('input[type="radio"]'), function (radio) {
            radio.setAttribute('disabled', 'disabled');
        });

        document.getElementById('submit-claim').setAttribute('disabled', 'disabled');
    }
}

export function customInitClaim(claim) {
    /**
     * Basically doing most edits in here because reasons.
     */
    console.log("Init claim[...]")

    // a.	Varsity Cheer Competitions: 
    e('[data-field-id="__wrapper_5"]').querySelector('p').innerHTML = `For each 
        year in which you paid for registration, entrance or other fees such as 
        accommodation expenses associated with participation in one or more 
        Varsity Cheer Competitions between <strong>December 10, 2016, and 
        March 31, 2024</strong>, place the total number of cheer athletes you 
        paid for in the corresponding box below. For example, if you paid for 
        one cheer athlete to participate in Varsity Cheer Competitions in 2021, 
        and two cheer athletes in 2022, place a “1” in the box for 2021, and a 
        “2” in the box for 2022. For any year in which you did NOT pay 
        any such fees, leave the box empty.`
    e('[data-field-id="_sect4a"]').querySelector('div').classList.add('row')

    // b.	Varsity Cheer Camps:  
    e('[data-field-id="__wrapper_8"]').querySelector('p').innerHTML = `For each 
        year in which you paid fees to participate in Varsity Cheer Camps 
        between <strong>December 10, 2016, and March 31, 2024</strong>, place 
        the total number of cheer athletes you paid for in the corresponding 
        box below.`
    e('[data-field-id="_sect4b"]').querySelector('div').classList.add('row')

    // c.	Varsity Cheer Apparel:  
    e('[data-field-id="__wrapper_11"]').querySelector('p').innerHTML = `For each 
        year that in which you purchased Varsity Cheer Apparel between 
        <strong>December 10, 2016, and March 31, 2024</strong>, place the total 
        number of cheer athletes you paid for in the corresponding box below.`
    e('[data-field-id="_sect4c"]').querySelector('div').classList.add('row')

    ee('.form-check-inline').forEach(div => {

        div.classList.remove('form-check-inline')
        div.classList.add('col-4', 'mb-1')

        let input = div.querySelector('input')
        input.type = 'number'
        input.classList.remove('form-check-input')
        input.classList.add('form-control', 'd-inline-block', 'me-1', 'textField')
        input.style.width = '64px'
        input.step = '1'
        input.min = '1'
    });

    document.getElementById('athlete_name').setAttribute('data-label', 'Athlete Full Name');

    e('[data-field-id="__wrapper_4"]').classList.add('d-none');
    e('[data-field-id="__wrapper_5"]').classList.add('d-none');
    e('[data-field-id="__wrapper_7"]').classList.add('d-none');
    e('[data-field-id="__wrapper_8"]').classList.add('d-none');
    e('[data-field-id="__wrapper_10"]').classList.add('d-none');
    e('[data-field-id="__wrapper_11"]').classList.add('d-none');
    e('[data-field-id="_sect4a"]').classList.add('d-none');
    e('[data-field-id="_sect4b"]').classList.add('d-none');
    e('[data-field-id="_sect4c"]').classList.add('d-none');

    return claim;
}